import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-64c2aa50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "avatars-container"
}
const _hoisted_2 = { key: 0 }

import { computed, ref, watch } from "vue";
import axios from "axios";
import useWindowWidth from "../../composables/useWindowWidth";
import { UserProfileApiModel, NotificationApiModel } from "../../api-models";
import UserAvatar from "../reusables/user-avatar.vue";
import useTeamMembers from "../../composables/useTeamMembers";
import useGetUserPathwayData from "../../composables/useGetUserPathwayData";
import AvatarDropdown from "./avatar-dropdown.vue";

const MAX_AVATARS_IN_LIST = 4;


export default /*#__PURE__*/_defineComponent({
  __name: 'avatar-list',
  props: {
    teamId: {},
    resourceId: {},
    actionType: {}
  },
  setup(__props: any) {

const props = __props;

const users = ref<UserProfileApiModel[]>([]);
const usersWhoHaveCompleted = ref<UserProfileApiModel[]>([]);

const { isMobile } = useWindowWidth();

const { teamMembers, error, fetchUserProfiles } = useTeamMembers(props.teamId);
const { getPersonalPathwayStepCompletionById, getTeamPathwayStepCompletionById } =
  useGetUserPathwayData();

async function fetchUserNotifications(userId: string) {
  const response = await axios.get<NotificationApiModel[]>(`/api/usernotifications/${userId}`);
  const notifications = response.data;
  return notifications;
}

async function usersWhoHaveCompletedTheResource(
  userProfiles: UserProfileApiModel[],
  resourceId?: string,
) {
  if (!resourceId) return [];

  if (props.actionType === "Pathway") {
    const pathwayUsersPromises = userProfiles.map(async (user) => {
      const hasCompletedPersonal = await getPersonalPathwayStepCompletionById(user.id, resourceId);
      const hasCompletedTeam = await getTeamPathwayStepCompletionById(user.id, resourceId);
      return hasCompletedPersonal || hasCompletedTeam ? user : null;
    });

    const pathwayUsersWithNulls = await Promise.all(pathwayUsersPromises);
    const pathwayUsers = pathwayUsersWithNulls.filter((user) => user !== null);

    return pathwayUsers as UserProfileApiModel[];
  }

  return userProfiles.filter(async (user) => {
    const notifications = await fetchUserNotifications(user.id);
    return notifications.some((notification) => {
      return notification.resourceId === resourceId && notification.actionStatus === "Completed";
    });
  });
}

watch(teamMembers, async (newTeamMembers, oldTeamMembers) => {
  if (newTeamMembers === undefined) return;
  users.value = await fetchUserProfiles(newTeamMembers.currentMembers);
  usersWhoHaveCompleted.value = await usersWhoHaveCompletedTheResource(
    users.value,
    props.resourceId,
  );
});

const usersSortedByCompletion = computed(() => {
  const copy = [...users.value];
  return copy.sort((a, b) => {
    const aHasCompleted = usersWhoHaveCompleted.value.includes(a);
    const bHasCompleted = usersWhoHaveCompleted.value.includes(b);

    if (aHasCompleted && !bHasCompleted) return -1;
    if (!aHasCompleted && bHasCompleted) return 1;
    return 0;
  });
});

const firstFiveUsers = computed(() => {
  return usersSortedByCompletion.value.slice(0, MAX_AVATARS_IN_LIST);
});

const restOfUsers = computed(() => {
  return usersSortedByCompletion.value.slice(MAX_AVATARS_IN_LIST);
});

function avatarVariant(user: UserProfileApiModel) {
  if (props.actionType === "Invite") return "default";
  return usersWhoHaveCompleted.value.includes(user) ? "default" : "faded";
}

function getTooltipText(user: UserProfileApiModel) {
  if (props.actionType === "Invite") return "";
  return usersWhoHaveCompleted.value.includes(user)
    ? `${user.firstName} ${user.lastName} (completed)`
    : `${user.firstName} ${user.lastName} (incomplete)`;
}

function dropdownTriggerText(): string {
  if (isMobile()) return "Team tracker";
  return `+${users.value.length - MAX_AVATARS_IN_LIST}`;
}

return (_ctx: any,_cache: any) => {
  return (!_unref(error))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstFiveUsers.value, (user) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "avatar-list__item",
            key: user.id,
            "data-test": "avatar-list"
          }, [
            _createVNode(UserAvatar, {
              user: user,
              size: "30px",
              variant: avatarVariant(user),
              "tooltip-text": getTooltipText(user)
            }, null, 8, ["user", "variant", "tooltip-text"])
          ])), [
            [_vShow, !_unref(isMobile)()]
          ])
        }), 128)),
        (users.value.length > MAX_AVATARS_IN_LIST || _unref(isMobile)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(AvatarDropdown, {
                users: _unref(isMobile)() ? usersSortedByCompletion.value : restOfUsers.value,
                "users-who-have-completed": usersWhoHaveCompleted.value,
                "trigger-text": dropdownTriggerText(),
                "action-type": props.actionType
              }, null, 8, ["users", "users-who-have-completed", "trigger-text", "action-type"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})